import api from "../../../utils/api";

// ✅ Fetch all gate visitor records
export const fetchAllGateVisitors = () => api.get(`/gate-visitors`);

// ✅ Fetch all statuses
export const fetchGateVisitorStatuses = () => api.get(`/gate-visitor-statuses`);

// ✅ Fetch all visitor types
export const fetchGateVisitorTypes = async () => {
  const response = await api.get(`/gate-visitor-types`);
  return response.data;
};
